import { useEffect } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { Link, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import axios from 'axios';
import { setMenuSelected } from '../redux/actions/menuActions';
import { setFiltering } from '../redux/actions/filteringActions';
import { setVybaveni } from '../redux/actions/prvkyActions';
import Filtering from '../comp/Filtering';
import ListingVybaveni from '../comp/ListingVybaveni';
import URLEndPointBE from '../comp/URLEndPointBE';

function SeznamVybaveni() {
    const { keycloak, initialized } = useKeycloak();
    let { params } = useParams();
    const dispatch = useDispatch();
        //potential succ from insertion/edit redirect
        const {state} = useLocation();
        console.log(state)
    const vybaveni = useSelector((state: any) => state.allPrvky.vybaveni);
    const filtVybaveni = useSelector((state: any) => state.filtStates.filtVybaveni);
    //const pouziti = useSelector((state: any) => state.miscDicts.pouziti);

    const filtering_list = Object.entries(filtVybaveni).map((filt: any) => (filt[1]===true)&&filt[0])
    // pouziti_list_ids not needed here
    //    
    
    let vybaveni_filtered = vybaveni.filter((vybav: any) => (vybav.vybaveniPouziti!=null)&&(vybav.vybaveniPouziti.some((pouz: any) => filtering_list.includes(pouz.rodina_kod))))
    //TODO rewrite debug to function if vybaveni!=[]
    /*
    console.log("<SeznamVybaveni debug of vars")
    console.log("vybaveni")
    console.log(vybaveni)
    */
    /*
    console.log("filtVybaveni")
    console.log(filtVybaveni)
    console.log("filtering_list")
    console.log(filtering_list)
    console.log("vybaveni_filtered")
    console.log(vybaveni_filtered)
    console.log("-END-")
    */
    const FetchVybaveni = async () => {
        const response: any = await axios
            .get(URLEndPointBE+`/listing/vybaveni`)
            .catch((error) => {
                console.log("Err", error)
            });
        return response.data;    
        //dispatch(setVybaveni(response.data))
    }
    const FetchSetRodinyVybaveni = async () => {
        const _rodiny_vybaveni: any = await axios
            .get(URLEndPointBE+`/dict-misc/rodiny-vybaveni`)
            .catch((error) => {
                console.log("Err rodiny vybaveni", error)
            });
        let _rodiny_vybaveni_state = _rodiny_vybaveni.data.reduce((objVals: any, v: any)=>({...objVals, [v.kod]: true}), {})
        dispatch(setFiltering({flag: "VYBAVENI", filtering: _rodiny_vybaveni_state}))   
    }

    const FilteringAllFalseCombined = async (params: any) => {
        const _rodiny_vybaveni: any = await axios
            .get(URLEndPointBE+`/dict-misc/rodiny-vybaveni`)
            .catch((error) => {
                console.log("Err rodiny vybaveni", error)
            });
        let _rodiny_vybaveni_state = _rodiny_vybaveni.data.reduce((objVals: any, v: any)=>({...objVals, [v.kod]: false}), {}) 
        for(let p of params) {
            _rodiny_vybaveni_state[p]=true;
        }
        dispatch(setFiltering({flag: "VYBAVENI", filtering: _rodiny_vybaveni_state}))   
    }

    useEffect(() => {
        dispatch(setMenuSelected("vybaveni"));

        const vybaveni = FetchVybaveni();
        Promise.resolve(vybaveni).then((result) => {
            dispatch(setVybaveni(result));
        });

        if(typeof(params) !== 'undefined') {
            let opt_params = params.split(';')
            FilteringAllFalseCombined(opt_params)
        } else {
            FetchSetRodinyVybaveni();
        }
    }, [])

    return (
        <Container>
            {/*/@ts-ignore*/}
            {(state?.succ)?<Row className={"succRow"}>
                {/*/@ts-ignore*/}
                <span className={"succTxtInside"}>Úspěch - {state?.type} {state?.item} </span>
            </Row>:<></>}
            <Row className="prvkyControl printHide">
                <Col className='boxBorderAround'>
                    <span className='alignLeft'><h2><b>SEZNAM VYBAVENÍ</b></h2></span>
                    {keycloak.authenticated && (
                    <Link className="navRemoveUnderscoreInLinkA" to="/vybaveni/new">
                        <span className="katBtnStyle">NOVÝ ZÁZNAM</span>
                    </Link>
                    )}
                </Col>
                <Col className='boxBorderAround'>
                    <Filtering caption="VÝBĚR DLE POUŽITÍ" flag="VYBAVENI" param={filtVybaveni}/>
                </Col>
            </Row>
            { (keycloak.authenticated)
              ? <ListingVybaveni vybaveni={vybaveni_filtered}/>
              : <ListingVybaveni vybaveni={vybaveni_filtered.filter((vyb: any)=> vyb.viditelnost==1)}/> }

        </Container>
    )
};
export default SeznamVybaveni